// src/pages/MyTasks.jsx
export default function MyTasks() {
  return (
    <div className="pm-ph">
      <div className="pm-ph-ico">✓</div>
      <h3>My tasks</h3>
      <p>7 tasks assigned to you.</p>
    </div>
  );
}